export const DEFAULT_LABELS = {
  default: 'There is no content.',
  event: 'There are no events.',
  course: 'There are no courses.',
  thumbnail: 'There is no thumbnail.',
};
